// extracted by mini-css-extract-plugin
export default {"AppPageTitle":"AppPageTitle_AppPageTitle__1KeUB","AppPageTitle__container":"AppPageTitle_AppPageTitle__container__+NOlX"};